import { ResearchType, SearchRequestParams, APIErrorResponse } from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from './useQueryList'

export const useResearchTypes = (
  { search, ...params }: SearchRequestParams,
  enabled = true
): UseQueryResult<ResearchType[], APIErrorResponse> =>
  useQueryList({
    url: '/protocols/research_types/',
    options: {
      enabled,
    },
    params: {
      ...params,
      ...(search ? { search } : {}),
    },
  })
